module.exports = __webpack_public_path__ + "static/media/PZ_2_etapa.7757ab1f.jpg";